"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPropertyAgent = void 0;
exports.defaultPropertyAgent = {
    id: 1,
    name: 'John Doe',
    title: 'PHD - Permenant Head Damage',
    license: 'S-123456',
    image: 'https://images.okay.com/AgentThumbnail/Source/499_636166458171722014.jpg',
};
